import { getData, postData } from "@/utils/http";
export default {
    namespaced: true,
    state: {
        tableLoading: true,
        activeItem: null
    },
    mutations: {
        CHANGE_TABLE_LOADING(state, tableLoading) {
            state.tableLoading = tableLoading;
        },
   
    
        CHANGE_ACTIVE_ITEM(state, item) {
            state.activeItem = item;
        },
        CHANGE_SEARCH_COLL(state,changeData){
            if(changeData["changeKey"]=="orgId"&&typeof changeData["data"]!="object"){
                state[changeData["changeKey"]] = [changeData["data"]];
            }else{
                state[changeData["changeKey"]] = changeData["data"];
            }
        },
    },
    actions: {
        //获取列表
        getHomeCarList({ commit, state }) {
           
            return new Promise((resolve) => {
                getData("supervise/index/car/data").then((res) => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data:res.data,
                            msg: "操作成功"
                        });
                    } else {
                        resolve({
                            state: 0,
                            data:[],
                            msg: res.msg
                        });
                    }
                })
            })
        },

        //根据车牌获取车辆运单信息
        getHomeBillList({ commit, state }, carNo) { 
          return new Promise((resolve) => {
                getData(`supervise/car/${carNo}`).then((res) => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data:res.data,
                            msg: "操作成功"
                        });
                    } else {
                        resolve({
                            state: 0,
                            data:[],
                            msg: res.msg
                        });
                    }
                })
            })
        },


        //获取站点
        getStationList({ commit, state }, carNo) { 
          return new Promise((resolve) => {
                getData(`supervise/station/list`).then((res) => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data:res.data,
                            msg: "操作成功"
                        });
                    } else {
                        resolve({
                            state: 0,
                            data:[],
                            msg: res.msg
                        });
                    }
                })
            })
        },

        //写入当前操作t条目
        setActiveItem({ commit }, item) {
            commit("CHANGE_ACTIVE_ITEM", item)
        },


        //写入查询条件
        setSearchData({commit},changeData){
            commit("CHANGE_SEARCH_COLL",changeData)
        },

       

        changeListLoading({ commit }, value) {
            commit("CHANGE_TABLE_LOADING", value)
        }
    }
}
